import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import BrandSpinner from "../../shared/components/BrandSpinner";
import { persistMicrosoftTenantId } from "./msalConfig";

export default function AuthRedirect() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const processRedirect = async () => {
      try {
        const response = await instance.handleRedirectPromise();

        if (response?.account) {
          persistMicrosoftTenantId(response);
          instance.setActiveAccount(response.account);
        } else {
          const accounts = instance.getAllAccounts();
          if (accounts.length > 0) {
            persistMicrosoftTenantId(accounts[0]);
            instance.setActiveAccount(accounts[0]);
          }
        }

        const redirectUrl = sessionStorage.getItem("msal.login.request.url");

        if (redirectUrl) {
          const targetPath =
            redirectUrl
              .replace(window.location.origin, "")
              .replace(/^\/app(?=\/|$)/, "") || "/home";

          navigate(targetPath === "/" ? "/home" : targetPath, {
            replace: true,
          });
        } else {
          navigate("/outlook/calendar", { replace: true });
        }
      } catch (err) {
        console.error("MSAL redirect error:", err);
        navigate("/outlook/calendar", { replace: true });
      }
    };

    processRedirect();
  }, [instance, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <BrandSpinner />
    </Box>
  );
}
